<div class="container-page">
    <div class="titulos">
        <div class="img-copas-botella-1" >
            <img src="{{config.image}}" alt="">
        </div>
        <div class="texto-inicial">
            <div [innerHTML]="config.titleBanner"></div>
            <p [innerHTML]="config.paragraph"></p>
            <a href="{{config.buttonUrl}}" class="comienza" id="myBtn">{{config.buttonText}}</a>
        </div>
    </div>
</div>
